export { default } from './NotFound';



// WEBPACK FOOTER //
// ./src/components/Common/NotFound/index.js